'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatDrawer } from 'blocks-nextjs/blocks-react/components/Drawer';
import ContactUsOptions from 'components/contact-us-options/contact-us-options';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import styles from './warranty-information-drawer.module.scss';
import cx from 'classnames';

export interface WarrantyInformationDrawerProps {
  esite: string;
  dealerPhone: string;
  helpCenterContactSupportUrl: string;
  orientation?: 'side' | 'bottom';
}

const WarrantyInformationDrawer = ({
  esite,
  dealerPhone,
  helpCenterContactSupportUrl,
  orientation = 'side'
}: WarrantyInformationDrawerProps) => {
  const t = useTranslations();
  const [drawerActive, setDrawerActive] = useState(false);
  const dealerLocatorDrawer = useDealerLocatorDrawer();

  const handleCloseDrawer = () => {
    setDrawerActive(false);
  };

  return (
    <>
      <CatButton
        onClick={() => {
          setDrawerActive(true);
        }}
        variant="ghost"
        className={styles['warranty-information-drawer__btn']}
      >
        {t('WARRANTY_INFO')}
      </CatButton>
      <CatDrawer
        className={cx({
          [styles['warranty-information-drawer']]: orientation === 'bottom'
        })}
        isActive={drawerActive}
        data-testid="warranty-information-drawer"
        onBlDrawerClose={handleCloseDrawer}
        orientation={orientation}
        verticalMaxHeight="large"
      >
        <div slot="header" className="cat-u-theme-typography-title-sm">
          {t('WARRANTY_INFO')}
        </div>
        <p className="cat-u-theme-typography-body">{t('WARRANTY_STATEMENT')}</p>
        <ContactUsOptions
          esite={esite}
          dealerPhone={dealerPhone}
          helpCenterContactSupportUrl={helpCenterContactSupportUrl}
          onClickFindDealer={() => dealerLocatorDrawer.openDrawer()}
        />
      </CatDrawer>
    </>
  );
};

export default WarrantyInformationDrawer;
